export default "__VITE_ASSET__BM20DO$Y__"